import React, { useState, useEffect } from "react";

const withMultiSelectGridCountryCheckbox = (WrappedComponent) => {
    return (props) => {
        const [selectedValues, setSelectedValues] = useState(props.value || []);
        const [anchorEl, setAnchorEl] = useState(null);

        useEffect(() => {
            const colId = props.column.colId;
            props.node.setDataValue(colId, selectedValues);
        }, [selectedValues, props.column.colId, props.node]);

        const toggleCheckbox = (opt) => {
            const isOptSelected = selectedValues.some(
                (selected) => selected.value === opt.value,
            );
            const newValues = isOptSelected
                ? selectedValues.filter(
                      (selected) => selected.value !== opt.value,
                  )
                : [...selectedValues, opt];

            if (newValues.length === 0) {
                alert("At least one element must be selected!");
                return;
            }
            setSelectedValues(newValues);
        };

        const handleClose = () => {
            const colId = props?.column?.colId;
            const rowNode = props.api.getRowNode(props.node.id);
            if (rowNode) {
                const updatedData = {...rowNode.data, [colId]: selectedValues};
                rowNode.setData({...rowNode.data, [colId]: selectedValues});
            }
            props.api.stopEditing(true);
        };

        useEffect(() => {
            setAnchorEl(props.eGridCell);
        }, [props.eGridCell]);

        const isOptionChecked = (option) => {
            return selectedValues?.some(
                (selected) => selected.value === option?.value,
            );
        };

        const injectedProps = {
            toggleCheckbox,
            anchorEl,
            handleClose,
            isOptionChecked,
        };

        return <WrappedComponent {...props} {...injectedProps} />;
    };
};

export default withMultiSelectGridCountryCheckbox;
